import {
  Backdrop,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
  Button,
} from '@mui/material'

const ApprovalDialong = (props) => {
  const {
    open,
    closeModal,
    isPending,
    approveHandler,
  } = props

  return (
    <Backdrop
      open={open}
      className="modal-filter"
    >
      <Dialog
        open={open}
        onClose={closeModal}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle
          sx={{ textAlign: "center", textTransform: "uppercase" }}
        >
          Approve Wallet Access
        </DialogTitle>
        <DialogContent sx={{textAlign: "center"}}>
          <DialogContentText>
            <Typography
              variant="div"
            >
              You must give permission to access <br/> your wallet before staking.
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{p:2}}>
          <Button
            variant="outlined"
            fullWidth
            className="btn-info btn-lg"
            onClick={isPending ? null : approveHandler}
          >
            {isPending ? "Pending..." : "Approve"}
          </Button>
          <Button
            color="primary"
            className="btn-default btn-lg"
            fullWidth
            onClick={closeModal}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Backdrop>
  )
}

export default ApprovalDialong;